import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../stores/Hooks';
import { SignTypeEnum } from '../../models';
import { ModalTypeEnum } from '../../stores/libraries/ModalLibrary';

export const ModalMessageStatementSignSelector: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();
		const store = uiState.stat;

		return (
			<>
				<div className="modal-content">
					<p>Подписать заявление необходимо квалифицированной электронной подписью руководителя организации, действующего от ее имени без доверенности.</p>
					<p className="mb-3">Выберите способ подписания заявления оператора ЭДО:</p>
					<div className="main-steps-form">
						<div className="form-block">
							<div className="formCheck mb-3">
								<label className="input-btns radio-btn">
									<input
										type="radio"
										name="SignType"
										onChange={(event: React.SyntheticEvent) => { if ((event.target as HTMLInputElement).checked) { store.setSignType(SignTypeEnum.ByBrowser) } }}
										checked={store.SignType === SignTypeEnum.ByBrowser}
									/>
									<span className="input-indicator"></span>
									<span>Подписать на веб-странице с помощью плагина</span>
								</label>
							</div>

							<div className="formCheck">
								<label className="input-btns radio-btn">
									<input
										type="radio"
										name="SignType"
										onChange={(event: React.SyntheticEvent) => { if ((event.target as HTMLInputElement).checked) { store.setSignType(SignTypeEnum.ByLoadFile) } }}
										checked={store.SignType === SignTypeEnum.ByLoadFile}
									/>
									<span className="input-indicator"></span>
									<span>Загрузить файл подписи</span>
								</label>
							</div>
						</div>
						{store.SignType === SignTypeEnum.ByBrowser &&
							<div className="signup-message">
								<p className="mb-0">Для подписи вам потребуется <a href="https://www.cryptopro.ru/products/cades/plugin" target="_blank" rel="noopener noreferrer nofollow" className="link">КриптоПро ЭЦП Browser plug-in</a></p>
							</div>
						}

						{store.SignType === SignTypeEnum.ByLoadFile &&
							<div className="signup-message">
								<p className="mb-0">
									Для загрузки файла подписи необходимо скачать
									<a download="Заявление_оператора_ЭДО.pdf" href={dataState.GetFormLink()} target="_blank" rel="noopener noreferrer nofollow" className="link">Заявление оператора ЭДО.pdf</a>
									и подписать квалифицированной электронной подписью руководителя оператора ЭДО,
									действующего от имени организации без доверенности.
								</p>
								<p className="mb-0">
									Подпись должна быть открепленной, и при этом в одной из следующих кодировок: DER, PEM, Base64
								</p>
							</div>
						}
					</div>
				</div>
				<div className="modal-footer">
					<div className="d-flex align-items-center">
						<button
							type="button"
							className="btn btn-primary ml-auto"
							disabled={store.SignType === SignTypeEnum.None}
							onClick={() =>
							{
								uiState.modal.setShowModal(
									true,
									store.SignType === SignTypeEnum.ByLoadFile ? ModalTypeEnum.LoadSignature : ModalTypeEnum.DoSignature,
									store.SignType === SignTypeEnum.ByLoadFile ? "Загрузка подписи руководителя организации, действующего от ее имени без доверенности" : "Выбор сертификата");
							}}
						>Продолжить</button>
					</div>
				</div>
			</>
		);
	}
)
